import { API } from "@swivl-mono/api-helper";
import { IsSessionTakenOver, SessionInterface, UserInterface } from "@swivl-mono/types";
import { Button, ButtonColor } from "@swivl-mono/ui";
import { AnimatePresence, motion } from "motion/react";
import { ImPhone } from "react-icons/im";
import CallModel, { CallBarPosition } from "../../../../../Models/CallModel/Call.Model";
import { Member } from "../../../../../Models/Member/Member.Current";
import { UsersModel } from "../../../../../Models/Users/Users.Model";

export function ChatFooterVoice(props: { centerX: number, user: UserInterface, session?: SessionInterface }) {
  const { centerX, user, session } = props;
  const { callBarPosition, escalationId } = CallModel.useState((state) => state);
  const isCallBarOpen = callBarPosition !== CallBarPosition.Hidden && callBarPosition === CallBarPosition.BottomCenter ? true : false;

  const handleCall = async () => {
    if (user.orgId && user.phoneNumber && Member.id) {
      const session = await API.Escalations.startOutboundVoiceEscalation(user.orgId, user.id, Member.id as number)
      if (session && session.escalation?.assignedMemberId === Member.id) {
        console.log("Got session", session);
        // Now we can send out an outbound call
        CallModel.startOutbound(session.escalation)
      }
    }
  }

  let buttons: any = null;

  if (session && IsSessionTakenOver(session, Member.id)) {
    if (session.escalation?.assignedMemberId === Member.id) {
      if (escalationId && escalationId === session.escalationId) {
        return null;
      } else {
        console.log("Handing state show end call button");
        buttons = <Button
          color={ButtonColor.YELLOW}
          onClick={
            () => UsersModel.endTakeoverOfSession(session.id)
          }
        >
          End Takeover
        </Button>
      }
      console.log("Call in progress or ringing, not showing call button");
    } else {
      console.log("Session taken over by another agent, not showing call button");
      return null;
    }

  } else {
    buttons = <Button
      color={ButtonColor.YELLOW}
      onClick={handleCall}
    >
      <ImPhone /> Call {user?.firstName || "User"}
    </Button>
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="p-4 flex fixed h-[64px] bottom-4 w-[calc(33.33%-32px)] items-center justify-between rounded-md shadow-lg bg-white"
        key={callBarPosition}
        initial={{ opacity: 0, translateY: 80 }}
        animate={{ opacity: 1, translateY: isCallBarOpen ? 80 : 0 }}
        exit={{ opacity: 0, translateY: 80 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{ right: centerX }}
      >
        <span className="text-sm font-semibold">Voice Call</span>
        {buttons}
      </motion.div>
    </AnimatePresence>
  );
}
